import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'

/**
 * OfflineBanner - Fixed banner shown at the top of the app when offline.
 *
 * Listens to navigator.onLine and online/offline events.
 * Renders nothing when the connection is active.
 */
export function OfflineBanner() {
  const isOnline = useOnlineStatus()

  if (isOnline) return null

  return (
    <div className="shrink-0 flex items-center justify-center gap-2 px-4 py-1.5 bg-destructive text-destructive-foreground text-xs font-medium select-none z-50">
      <WifiOff className="h-3.5 w-3.5" />
      You're offline — check your internet connection
    </div>
  )
}
